import { ErrorMessageEnum } from "../enums/error-message.enum";
import { PASSWORD_STRENGTH_PATTERN } from "../constants/password-validation";

const validatePswMatch = (name: string, watchedPsw: any) => {
	const validateMatch = (val: string) => {
		if (val !== watchedPsw) {
			return ErrorMessageEnum.PASSWORD_MATCH;
		}
	};
	return {
		required: true,
		validate: {
			validateMatch,
		},
	};
};

const validatePswStrength = () => {
	const strengthIndicatorTest = (val: string) => {
		const rgx_pwd = PASSWORD_STRENGTH_PATTERN.test(val);

		if (val.length >= 10 && rgx_pwd) {
			return;
		}

		return ErrorMessageEnum.PASSWORD_STRENGTH;
	};
	return {
		required: true,
		validate: {
			strengthIndicatorTest,
		},
	};
};

export { validatePswMatch, validatePswStrength };
